<div class="verkada-camera-player">
  <div class="player-container">
    <sn-video-player
      [src]="currentStreamUrl"
      [autoplay]="autoplay"
      [aspectRatio]="ASPECT_RATIO.Classic"
      [caption]="caption"
      [muted]="true"
      (fullscreenChange)="onFullscreenChange($event)"
      width="100%"
    >
      <sn-player-footer-row *ngIf="isFullscreen">
        <div class="playback-controls">
          <sn-icon-button matTooltip="Back 5 Seconds" (click)="back(5)">
            <sn-icon>replay_5</sn-icon>
          </sn-icon-button>
          <sn-icon-button matTooltip="Jump to Beginning" (click)="jumpToBeginning()">
            <sn-icon>skip_previous</sn-icon>
          </sn-icon-button>
          <sn-icon-button matTooltip="Rewind" (click)="rewind()">
            <sn-icon>fast_rewind</sn-icon>
          </sn-icon-button>
          <sn-player-play-control class="play-control-padding"></sn-player-play-control>
          <sn-icon-button matTooltip="Fast Forward" (click)="fastForward()">
            <sn-icon>fast_forward</sn-icon>
          </sn-icon-button>
          <sn-icon-button
            matTooltip="{{ isHistoricalMode ? 'Jump to End' : 'Return to LIVE' }}"
            (click)="jumpToEnd()"
            [disabled]="!!(!isHistoricalMode && videoPlayer?.live)"
          >
            <sn-icon>skip_next</sn-icon>
          </sn-icon-button>
          <sn-icon-button
            matTooltip="Forward 5 Seconds"
            (click)="forward(5)"
            [disabled]="!!(!isHistoricalMode && videoPlayer?.live)"
          >
            <sn-icon>forward_5</sn-icon>
          </sn-icon-button>
          <sn-icon-button matTooltip="Take A Screenshot" (click)="screenshot()">
            <sn-icon>content_cut</sn-icon>
          </sn-icon-button>
          <button
            class="calendar"
            mat-icon-button
            (click)="onToggleCalendar()"
            matTooltip="Historical View"
          >
            <sn-icon size="md">date_range</sn-icon>
          </button>
        </div>
      </sn-player-footer-row>
      <sn-player-footer-row>
        <sn-player-progress-bar-control
          *ngIf="isHistoricalMode && !isSeekingToInitialPosition"
        ></sn-player-progress-bar-control>
      </sn-player-footer-row>
      <sn-player-footer-row>
        <sn-player-footer-section alignment="start">
          <sn-player-play-control></sn-player-play-control>
          <sn-player-volume-control></sn-player-volume-control>
          <sn-player-source-toggle-control
            (click)="liveButtonClick()"
            class="live-button"
          ></sn-player-source-toggle-control>
          <sn-player-hls-time-control *ngIf="isFullscreen"></sn-player-hls-time-control>
        </sn-player-footer-section>
        <sn-player-footer-section alignment="end">
          <span *ngIf="playbackStatusText" class="playback-status">{{ playbackStatusText }}</span>
          <sn-player-fullscreen-control></sn-player-fullscreen-control>
        </sn-player-footer-section>
      </sn-player-footer-row>
    </sn-video-player>
  </div>
</div>
